import DashboardInterno from './DashboardInterno'

export default DashboardInterno
